// extracted by mini-css-extract-plugin
module.exports = {"how__grid":"styles-module--how__grid--y1blK","how__description":"styles-module--how__description--3avS0"};